import { Card, CardActionArea, Link, styled, useTheme } from "@mui/material"
import { AlertIconContainer, PlugsIcon } from "../../../../icons"
import {
  Title as BaseTitle,
  BottomLabel,
  Container,
  HoverExternalLink,
  LabelsContainer,
  OuterContainer,
  confHoverExternalLink,
} from "../../commons"

export interface PurchaseLinkBoxProps {
  title?: string
  subtitle?: string
  href?: string
}

const defaultTtitle = "Il vous manque des données ?"
const defaultSubtitle =
  "Activez vos connecteurs Digipharmacie pour améliorer la complétude de vos achats par canaux"
const defaultHref =
  "https://app.digipharmacie.fr/account/keycloak/login/?process=login&next=%2Ffactures%2Fsynchronisation"
const tint = (color: string, pct: number) =>
  `color-mix(in srgb, ${color} ${pct}%, #fff)`

export const PurchaseLinkBox = ({
  title = defaultTtitle,
  subtitle = defaultSubtitle,
  href = defaultHref,
}: PurchaseLinkBoxProps) => {
  const { palette } = useTheme()
  const color = palette.common.electricBlue

  return (
    <Card sx={{ borderColor: tint(color, 56) }}>
      <CardActionArea
        component={Link}
        href={href}
        target="_blank"
        rel="noreferrer"
        sx={{
          ...confHoverExternalLink,
          p: 1.75,
          "& .MuiCardActionArea-focusHighlight": {
            backgroundColor: color,
          },
        }}
      >
        <OuterContainer>
          <Container>
            <AlertConnectorIcon color={color} />

            <LabelsContainer>
              <Title>{title}</Title>
              <Subtitle>{subtitle}</Subtitle>
            </LabelsContainer>
          </Container>

          <HoverExternalLink />
        </OuterContainer>
      </CardActionArea>
    </Card>
  )
}

const AlertConnectorIcon = ({ color }: { color: string }) => (
  <ConnectorIcon color={color}>
    <PlugsIcon color={color} />
  </ConnectorIcon>
)

const ConnectorIcon = styled(AlertIconContainer)<{ color: string }>(({ color }) => ({
  borderColor: tint(color, 56),
  backgroundColor: tint(color, 3),
}))

const Title = styled(BaseTitle)(({ theme }) => ({
  color: theme.palette.common.darkBlue,
}))

const Subtitle = styled(BottomLabel)(({ theme }) => ({
  color: theme.palette.common.darkBlue,
  whiteSpace: "normal",
}))
